
export default {
  data() {
    return {
      isMounted: false,
    };
  },

  mounted() {
    this.isMounted = true;
  },

  computed: {
    totalArticles() {
      if (!this.isMounted) return;
      else {
        let sum = 0;

        if (
          this.$refs.cartItems &&
          this.$refs.cartItems.cartItems &&
          this.$refs.cartItems.cartItems.length
        ) {
          this.$refs.cartItems.cartItems.forEach(
            (product) => (sum = sum + product.qty)
          );
        }
        return sum;
      }
    },
  },

  methods: {
    add(item) {
      this.$set(item, "qty", item.qty + 1);
    },
    remove(item) {
      if (item.qty > 1) {
        this.$set(item, "qty", item.qty - 1);
      }
    },
  },
};
